import React from "react";
import AppDialog from "../../../components/Common/AppDialog";
import "../../../components/Common/common.css";
import CustomTextField from "../../../components/Form/CustomTextField";
import CheckBoxGroupForApprove from "./CheckBoxGroupForApprove";
//Import Breadcrumb

const ApproveModal = ({
    open, values, setFormValues = false,
    setOpen, setPositivePress, platformData, setPlatformData }) => {
    return (
        <React.Fragment>
            <AppDialog
                open={open}
                titleIcon={"complete"}
                close={() => setOpen(false)}
                title={'Confirm product approval'}
                positiveTitle={'Approve product'}
                positiveButtonStyle={{ backgroundColor: '#101010', color: 'white', border: '1px solid #101010' }}
                positivePress={() => setPositivePress("Reject")}
                negativeTitle={'Cancel'}
                negativePress={() => setOpen(false)}
                width={'30%'}
            >
                <div className="">
                    <CheckBoxGroupForApprove title="Select the platform(s) to approve this product for listing: " data={platformData} setCheckBoxValue={setPlatformData} row={true} setValue={setFormValues} values={values?.platform_availability}
                        onChange={(e) => (
                            e.target.value === "is_ariba_product" &&
                            setFormValues((prevValues) => ({
                                ...prevValues,
                                is_ariba_product: e.target.checked ? 1 : 0,
                            })),
                            e.target.value === "is_aspeed_product" &&
                            setFormValues((prevValues) => ({
                                ...prevValues,
                                is_aspeed_product: e.target.checked ? 1 : 0,
                            }))

                        )
                        }
                    />
                </div>
            </AppDialog>
        </React.Fragment>
    );
};

export default ApproveModal;
